import axios from './index'

export default {
  list(params) {
    return axios.get('/api/v1/event/list', { params })
  },
  listMovements(params) {
    return axios.get('/api/v1/event/qr/movements-table', { params })
  },
}